import { Box, Button, Card, Grid, Typography } from '@mui/material';
import NextLink from 'next/link';
import Layout from '@common/layouts';

import Page from '@common/components/Page';
import OverrideList from '../../sections/override/OverrideList';
import { PATH_OVERRIDE } from '../../routes/paths';

// ----------------------------------------------------------------------

OverridePage.getLayout = function getLayout(page: React.ReactElement) {
  return <Layout>{page}</Layout>;
};

export default function OverridePage() {
  return (
    <Page title="Override" height={'100%'}>
      <Grid container spacing={3} sx={{ marginTop: '12px' }}>
        <Grid item xs={12} md={8}>
          <Card
            sx={{
              p: 3,
              overflow: 'initial',
              width: '1200px' /* width is wanted, otherwise the filters glitch a bit */,
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="h4" gutterBottom>
                Override
              </Typography>
              <NextLink href={PATH_OVERRIDE.create} passHref>
                <Button variant="contained">New Override</Button>
              </NextLink>
            </Box>
            <OverrideList />
          </Card>
        </Grid>
      </Grid>
    </Page>
  );
}
